import axiosNewApi from "../config/axiosNewApi";

export const shippingAddresses = async () => {
  try {
    const response = await axiosNewApi.get(`mobile/carts/shipping-address`, {
      withCredentials: true,
    });

    if (response.status === 200) {
      return response.data;
    } else {
      throw new Error("No shipping Addresses found.");
    }
  } catch (error) {
    console.error("Error fetching shipping Addresses :", error.message);
    throw new Error("An error occurred while fetching shipping Addresses.");
  }
};
